export const API_VERSION = process.env.REACT_APP_API_VERSION || "v1";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000/api";